/* global wc_add_to_cart_params */
import Modal from 'modules/Modal';


export default (function() {
	let cross_sells = [];

	function init(button, product_id, quantity, var_id) {
		const addCrossSells = $('.js-add-cross-sell');

		// wc_cart_params is required to continue, ensure the object exists
		if (typeof wc_add_to_cart_params === 'undefined') {
			return false;
		}

		// Populate checked cross-sells products
		addCrossSells.each((i, el) => {
			const cross_sell_id = $(el).data('product-id');

			if ($(el).is(':checked')) {
				cross_sells.push(cross_sell_id);
			}
		});

		addToCart(button, product_id, quantity, var_id, cross_sells);
	}

	function addToCart(button, product_id, quantity, var_id, cross_sells) {
		const data = {
			action      : 'add_single_product_to_cart',
			security    : window.theme.ajax_nonce,
			product_id  : product_id,
			variation_id: var_id,
			quantity    : quantity,
			cross_sells : cross_sells
		};

		$('body').trigger('adding_to_cart', [button, data]);

		// Update Cart Totals
		$.ajax({
			url : wc_add_to_cart_params.ajax_url,
			type: 'post',
			data: data,
			beforeSend: () => {
				$(button).addClass('is-submitting');
			},
			success: (response) => {
				if (!response)
					return;

				// Redirect to cart when success
				if (response.success && response.cart_url) {
					window.location.href = response.cart_url;

				// Stay on page and update mini cart
				} else if (response.success && response.mini_cart) {
					$(button)
						.removeClass('is-submitting')
						.closest('.js-add-to-cart')
						.addClass('in-cart')
						.find('.js-proceed-to-cart')
						.addClass('show');

					$('.js-cart-mini').replaceWith(response.mini_cart);

				// Redirect to product page on error
				} else if (!response.success && response.product_url) {
					// window.location = response.product_url;
					window.alert('Something went wrong, please try again.');
					return;
				}
			},
			error: (jqXHR, error) => {
				console.log(jqXHR, error);
			}
		});
	}

	return {
		init
	};
})();